import { ApiResponse } from "../lib/api.ts";
import { userService } from "../services/user-service.ts";
import { AdminAuthResponse, NotificationData, NotificationRequest, UpdateUserRequest, UserData, UserFullData } from "../entry/server/user.ts";

export const userRepo = {
    login: async (username: string, password: string): Promise<ApiResponse<AdminAuthResponse>> => {
        const res = await userService.login(username, password);
        if (res.status) {
            sessionStorage.setItem("token", res.data?.token ?? "");
            sessionStorage.setItem("user", JSON.stringify(res.data?.user));
        }
        return res;
    },
    getUsers: async (page: number, limit: number, search?: string): Promise<ApiResponse<UserData[]>> => {
        return await userService.getUsers(page, limit, search);
    },
    getUser: async (id: number): Promise<ApiResponse<UserFullData>> => {
        return await userService.getUser(id);
    },
    updateUser: async (id: number, payload: UpdateUserRequest): Promise<ApiResponse<any>> => {
        return await userService.updateUser(id, payload);
    },
    deleteUser: async (id: number): Promise<ApiResponse<any>> => {
        return await userService.deleteUser(id);
    },
    deleteUserDevice: async (id: number, token: string): Promise<ApiResponse<any>> => {
        return await userService.deleteUserDevice(id, token);
    },
    getNotifications: async (page: number): Promise<ApiResponse<NotificationData[]>> => {
        return await userService.getNotifications(page);
    },
    createNotification: async (payload: NotificationRequest): Promise<ApiResponse<any>> => {
        return await userService.createNotification(payload);
    },
    deleteNotification: async (id: number): Promise<ApiResponse<any>> => {
        return await userService.deleteNotification(id);
    },
};